import { lazy } from 'react';

export const LicencesRoutes = {
  Licences: lazy(() =>
    import('@/modules/Licences/pages/Licences').then(({ Licences }) => ({
      default: Licences,
    })),
  ),
};
